import React from 'react';
import PropTypes from 'prop-types';

import ImmunotherapyIframe from '../ImmunotherapyIframe';
import FertilityIframe from '../FertilityIframe';

const IFRAME_INFO_TYPES = {
  FERTILITY_CONSULTATION: 'fertilityConsultation',
  IMMUNOTHERAPY_CONSULTATION: 'immunotherapyConsultation'
};

const BookingIframe = props => {
  const { data } = props;
  const type = data?.info?.type;

  if (type === IFRAME_INFO_TYPES.FERTILITY_CONSULTATION) {
    return <FertilityIframe {...props} />;
  }

  if (type === IFRAME_INFO_TYPES.IMMUNOTHERAPY_CONSULTATION) {
    return <ImmunotherapyIframe {...props} />;
  }

  return null;
};

BookingIframe.propTypes = {
  dispatch: PropTypes.func,
  conversationFlowStateKey: PropTypes.string,
  conversationId: PropTypes.string,
  userData: PropTypes.object,
  dataLoading: PropTypes.bool,
  data: PropTypes.shape({
    info: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  language: PropTypes.string,
  testCode: PropTypes.string
};

export default BookingIframe;
